import '@babel/polyfill'
import 'url-search-params-polyfill'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import './permission' // permission control
import VueStorage from 'vue-ls'
import config from '@/config/defaultSettings'

// base library
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

import bootstrap from './core/bootstrap'



Vue.use(Antd)
Vue.use(VueStorage, config.storageOptions)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  created: bootstrap,
  render: h => h(App)
}).$mount('#app')
